import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

const conversationTrainingLabelSchema_ = z.object({
  _id: zExt.objectId(),
  trainingSetId: z.string(),
  teamId: z.string(),
  conversationId: z.string(),
  messageId: z.string(),
  label: z.string(),
  notes: z.string(),
  createdAt: z.date(),
  updatedAt: z.date(),
});
export const ConversationTrainingLabelSchema: z.ZodType<ConversationTrainingLabel> =
  conversationTrainingLabelSchema_;
export interface ConversationTrainingLabel
  extends z.infer<typeof conversationTrainingLabelSchema_> {}

export enum TrainingSetId {
  CONCIERGE_GUARDRAILS_12_20_2024 = "concierge-guardrails-12_20_2024",
}
